import api from '@/services/api'

export default {
  /**
   * Get documents
   * @return {Array} documents
   */
  async getAll () {
    try {
      const res = await api.get('/documents')
      return res.data
    } catch (error) {
      throw `Documents api service ${error}`
    }
  },

  /**
   * Get one document by id
   * @return {Object} document
   */
  async getById (id) {
    try {
      const res = await api.get('/documents/' + id)
      return res.data
    } catch (error) {
      throw `Documents api service ${error}`
    }
  },


  /**
   * Create document
   * @param {Object} {name: String, description: String, url: String, isActive: Boolean}
   * @return {Number} id
   */
  async create (document) {
    try {
      let formData = new FormData()
      const data = {
        ...document,
        file: null
      }
      formData.append('data', JSON.stringify(data))
      formData.append('file', document.file)
      const res = await api.post('/documents', formData)
      return res.data
    } catch (error) {
      throw `Documents api service ${error}`
    }
  },

  /**
   * Update document
   * @param {Object} document 
   * @return {Object} document
   */
  async update (document) {
    try {
      const res = await api.put('/documents/' + document.id, document)
      return res.data
    } catch (error) {
      throw `Documents api service ${error}`
    }
  },

  /**
   * Delete one document by id
   * @param {Number} id
   */
  async delete (id) {
    try {
      const res = await api.delete('/documents/' + id)
      return res.data
    } catch (error) {
      throw `Documents api service ${error}`
    }
  }
}